var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRatedTrusted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2512_12165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4167 0.620117H11.9167C5.33 0.620117 0 5.95012 0 12.5368V79.7035C0 86.2901 5.33 91.6201 11.9167 91.6201H52.8667L54.21 86.2035L44.59 77.9701C41.5567 75.3701 40.3867 71.2535 41.6867 67.4401C41.9033 66.7901 42.1633 66.1835 42.5533 65.6201C44.1567 62.8468 47.06 61.0268 50.3533 60.8535L56.3333 60.5068L59.8867 60.2901L62.27 60.1601L66.69 48.2001C67.2533 46.6401 68.1633 45.3401 69.3333 44.3001V12.5368C69.3333 5.95012 64.0033 0.620117 57.4167 0.620117Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3333 25.5366V60.5066L50.3533 60.8533C47.06 61.0266 44.1567 62.8466 42.5533 65.6199H42.25C40.4733 65.6199 39 64.1466 39 62.37V25.5366C39 23.76 40.4733 22.2866 42.25 22.2866H53.0833C54.86 22.2866 56.3333 23.76 56.3333 25.5366Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0833 39.6201H16.25C14.456 39.6201 13 41.0761 13 42.8701V62.3701C13 64.1641 14.456 65.6201 16.25 65.6201H27.0833C28.8773 65.6201 30.3333 64.1641 30.3333 62.3701V42.8701C30.3333 41.0761 28.8773 39.6201 27.0833 39.6201Z",
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8867 60.2901L56.3333 60.5068L50.3533 60.8534C47.06 61.0268 44.1567 62.8468 42.5533 65.6201H10.8333C9.05666 65.6201 7.58333 64.1468 7.58333 62.3701C7.58333 60.5935 9.05666 59.1201 10.8333 59.1201H57.4167C58.4133 59.1201 59.28 59.5968 59.8867 60.2901Z",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.234 104.62C90.597 104.62 89.96 104.434 89.4053 104.057L75.8333 94.8223L62.2613 104.057C61.1433 104.811 59.6743 104.806 58.5693 104.031C57.4643 103.259 56.9487 101.877 57.2823 100.573L61.5073 83.8893L48.802 73.0429C47.7923 72.1806 47.411 70.7896 47.8313 69.533C48.256 68.2763 49.4043 67.401 50.726 67.3273L66.911 66.413L72.7783 50.423C73.2507 49.136 74.4727 48.2866 75.8333 48.2866C77.194 48.2866 78.416 49.136 78.884 50.4186L84.7513 66.4086L100.936 67.323C102.262 67.401 103.406 68.272 103.831 69.5286C104.256 70.7896 103.87 72.1763 102.86 73.0386L90.155 83.885L94.38 100.568C94.7137 101.877 94.198 103.255 93.093 104.026C92.534 104.425 91.884 104.62 91.234 104.62Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2512_12165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(0 0.620117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRatedTrusted);
export default __webpack_public_path__ + "static/media/top-rated-trusted.ea9688cca3f27c6dfc42ab1c0c438952.svg";
export { ForwardRef as ReactComponent };